// webapp/src/lib/conventionRealtime.js

/**
 * Build the per-cell save key used by the convention scoreboard. Mirrors the
 * key view.js doUpdateResult builds: `${participant}-${stage}-${stand || idx}`.
 * Field shooting keys on `stand`; target-based stages key on `targetIndex`.
 */
export function resultSaveKey({ participant, stage, stand, targetIndex } = {}) {
    const cell = (stand !== undefined && stand !== null && stand !== '') ? stand : targetIndex;
    return `${participant}-${stage}-${cell}`;
}

/**
 * Decide whether an incoming Firebase broadcast command should be applied to the
 * local page.
 *
 * @param {object}  payload      - the command payload (carries senderId, and for
 *                                 results: participant/stage/stand/targetIndex).
 * @param {string}  ownSenderId  - this tab's broadcast sender id (suppress echoes).
 * @param {boolean} ready        - false during the post-subscribe warm-up window,
 *                                 when Firestore replays the historical backlog.
 * @param {string[]} editingKeys - save keys of result cells being edited locally.
 */
export function shouldApplyCommand({ payload, ownSenderId, ready, editingKeys = [] } = {}) {
    if (!payload) {
        return false;
    }
    if (!ready) {
        return false;
    }
    if (payload.senderId === ownSenderId) {
        return false;
    }
    if (editingKeys.length && payload.participant !== undefined) {
        if (editingKeys.includes(resultSaveKey(payload))) {
            return false;
        }
    }
    return true;
}
